import { render, staticRenderFns } from "./UpsellPackages.vue?vue&type=template&id=0a5d7eb5&"
import script from "./UpsellPackages.vue?vue&type=script&lang=ts&"
export * from "./UpsellPackages.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports